import isPresent from "is-present"

export default function presence(object) {
  if (isPresent(object)) return object
}
